<template>
	<div class="container">
		<h1 class="border-bottom d-flex mb-5">Admin</h1>
		<b-overlay
			:show="loading"
			rounded="sm"
		>
			<b-tabs
				content-class="mt-5 mx-3"
				v-model="tab"
			>
				<b-tab
					title="Group view"
					active
				>
					<div class="mb-5 mx-auto w-50">
						<select
							class="form-control form-control-lg"
							v-model="groupId"
						>
							<option
								v-for="g in groups"
								:key="g._id"
								:value="g._id"
							>{{ g.name }} ({{ g.users.length }})</option>
						</select>
					</div>
					<div
						class="card shadow-sm"
						v-if="group"
					>
						<div class="card-body">
							<h4 class="card-title mb-4">
								<span
									:title="'ID: ' +  group._id"
									v-b-tooltip.hover.right
								>{{ group.name }}</span>
							</h4>
							<table class="mb-0 table table-sm">
								<thead>
									<tr>
										<th>User</th>
										<th></th>
										<th
											class="text-center"
											:colspan="roles.length"
										>Group roles</th>
										<th class="text-center">Save to</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="u in groupsUsers"
										:key="group._id + u._id"
									>
										<td class="w-100">
											<span
												:title="'ID: ' + u._id"
												v-b-tooltip.hover.right
											>
												<a
													href="javascript:void(0)"
													@click="selectedUser=u;tab=1"
												>{{ u.name }}</a>
												<br>
												<small>{{ u.email }}</small>
											</span>
										</td>
										<td>
											<span
												title="Remove from group"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-2"
													icon="person-x"
													role="button"
													variant="danger"
													@click="removeFromGroup(group, u)"
												/>
											</span>
										</td>
										<td
											:key="group._id + u._id + r"
											v-for="r in roles"
										>
											<span
												:title="r"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-2"
													role="button"
													:icon="icons[r]"
													:variant="group.roles[r].includes(u._id) ? 'success' : 'danger'"
													@click="toggleGroupRole(group, u, r)"
												/>
											</span>
										</td>
										<td>
											<span
												:title="u.default_save_to_group_name"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-4"
													role="button"
													:icon="icons.saveTo"
													:variant="group._id === u.default_save_to_group ? 'success' : 'danger'"
													@click="changeSaveTo(u, group)"
												/>
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card-footer">You can add users to groups on <a
								href="javascript:void(0)"
								@click="tab=1"
							>User view</a>.</div>
					</div>
				</b-tab>
				<b-tab title="User view">
					<div class="mb-5 mx-auto w-75">
						<v-select
							v-model="selectedUser"
							:options="userSelectOptions"
							label="name"
						/>
					</div>
					<div
						class="card shadow-sm"
						v-if="user"
					>
						<div class="card-body">
							<h4 class="card-title mb-4">
								<span
									:title="'ID: ' +  user._id"
									v-b-tooltip.hover.right
								>
									{{ user.name }}
									<br>
									<small>{{ user.email }}</small>
								</span>
							</h4>
							<p class="mb-4">
								Registered: {{ new Date(user.creation_date).toLocaleString() }}
								<b-icon
									class="ml-2"
									icon="google"
									v-if="user.google && user.google.id"
								/>
							</p>
							<table class="mb-0 table table-sm">
								<thead>
									<tr>
										<th>Scope</th>
										<th>
											<!-- verified is irrelevant in groups -->
										</th>
										<th
											class="text-center"
											:colspan="roles.length"
										>Roles</th>
										<th class="text-center">Save to</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td class="py-3 w-100">(Global)</td>
										<td
											:key="user._id + 'global' + r"
											v-for="r in [...global_extra_roles, ...roles]"
										>
											<span
												:title="r"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-2"
													role="button"
													:icon="icons[r]"
													:variant="user.roles.includes(r) ? 'success' : 'danger'"
													@click="toggleGlobalRole(user, r)"
												/>
											</span>
										</td>
										<td><span class="mx-4"><!-- avoiding column shrinking :) -->
											</span></td>
									</tr>
									<tr
										v-for="g in usersGroups"
										:key="user._id + g._id"
									>
										<td class="py-3 w-100"><a
												href="javascript:void(0)"
												:title="'ID: ' + g._id"
												@click="groupId=g._id;tab=0"
												v-b-tooltip.hover.right
											>{{ g.name }}</a></td>
										<td>
											<span
												title="Remove from group"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-2"
													icon="person-x"
													role="button"
													variant="danger"
													@click="removeFromGroup(g, user)"
												/>
											</span>
										</td>
										<td
											:key="user._id + g._id + r"
											v-for="r in roles"
										>
											<span
												:title="r"
												v-b-tooltip.hover.bottom
											>
												<b-icon
													class="mx-2"
													role="button"
													:icon="icons[r]"
													:variant="g.roles[r].includes(user._id) ? 'success' : 'danger'"
													@click="toggleGroupRole(g, user, r)"
												/>
											</span>
										</td>
										<td>
											<b-icon
												class="mx-4"
												role="button"
												:icon="icons.saveTo"
												:variant="g._id === user.default_save_to_group ? 'success' : 'danger'"
												@click="changeSaveTo(user, g)"
											/>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card-footer">
							<button
								class="btn btn-sm btn-outline-success m-2"
								v-for="g in newGroups"
								:key="'new'+g._id"
								@click="addUserToGroup(g, user)"
							>
								<b-icon
									class="mr-2"
									icon="person-plus"
								/>
								{{ g.name }}
							</button>
						</div>
					</div>
				<div class="card shadow-sm" v-if="user">
					<div class="card-body">
					<h4 class="card-title mb-4">Last uploads</h4>
				<table class="mb-0 table table-bordered table-hover table-striped table-sm" v-if = "user.latest_upload">
					<thead>
						<tr>
						<th> # </th>
						<th> time </th>
						<th> experiment_id </th>
						<th> animalName </th>
						<th> batch_id </th>
						<th> file_name </th>
						<th> batch_from_date </th>
						<th> batch_till_date </th>
						<th> created </th>
						<th> _id </th>
						<!--<th> measurement_id </th>-->
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(record,index) in
							user.latest_upload.slice().reverse()"
							:key="record.upload_time" >
						<td> {{index + 1}} </td>
						<td> {{(new Date(record.upload_time*1000)).toLocaleString("en-ZA")}} </td>
						<td> {{record.experiment_id}} </td>
						<td> {{record.animalName}} </td>
						<td> {{record.batch_id}} </td>
						<td> {{record.file_name}} </td>
						<td> {{record.batch_from_date}} </td>
						<td> {{record.batch_till_date}} </td>
						<td> {{record.batch_created}} </td>
						<td>
							<router-link :to="'/batch/' + record.m_id + '/' + record._id">
							{{ record._id }}
							</router-link>
						</td>
						</tr>
					</tbody>
				</table>
					</div>
				</div>
				</b-tab>
				<b-tab title="Global roles view">
					<div class="mb-5 mx-auto w-75">
						<select
							class="form-control form-control-lg"
							v-model="role"
						>
							<option
								v-for="r in [...global_extra_roles, ...roles]"
								:key="'global' + r"
								:value="r"
							>{{ r }}</option>
						</select>
					</div>
					<div
						class="card shadow-sm"
						v-if="role"
					>
						<div class="card-body">
							<h4 class="card-title mb-4">{{ role }}</h4>
							<table class="mb-0 table table-sm">
								<thead>
									<tr>
										<th>User</th>
										<th class="text-center">Action</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="u in rolesUsers"
										:key="role + u._id"
									>
										<td class="w-100">
											<span
												:title="'ID: ' + u._id"
												v-b-tooltip.hover.right
											>
												<a
													href="javascript:void(0)"
													@click="user=u;tab=1"
												>{{ u.name }}</a>
												<br>
												<small>{{ u.email }}</small>
											</span>
										</td>
										<td>
											<button
												class="btn btn-outline-success"
												v-if="role === 'unverified'"
												@click="toggleGlobalRole(u, 'verified')"
											>Verify</button>
											<button
												class="btn btn-outline-danger"
												v-else
												@click="toggleGlobalRole(u, role)"
											>Revoke</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="card-footer">You can add global roles to users on <a
								href="javascript:void(0)"
								@click="tab=1"
							>User view</a>.</div>
					</div>
				</b-tab>
			</b-tabs>
		</b-overlay>
	</div>
</template>

<script>
import apiClient from '../apiClient'
import icons from '../icons'

export default {
	data() {
		return {
			groupId: null,
			groups: [],
			icons,
			loading: false,
			role: 'unverified',
			roles: [
				'viewer',
				'downloader',
				'uploader',
				'editor',
				'admin'
			],
			global_extra_roles: [
				'verified',
				'breedmaintainer'
			],
			tab: 0,
			selectedUser: { _id: null },
			users: [],
		}
	},
	computed: {
		userId() {
			return this.selectedUser._id
		},
		userSelectOptions() {
			return this.users.map((u) => {
				return { _id: u._id, name: `${u.name} (${u.email})` }
			})
		},
		group() {
			return this.groups.filter((g) => g._id === this.groupId)[0]
		},
		groupsUsers() {
			return this.users
				.filter((u) => this.group.users.includes(u._id))
				.map((u) => {
					const g = this.groups.filter(
						(g) => g._id === u.default_save_to_group
					)[0]
					u.default_save_to_group_name = g ? g.name : '(N/A)'
					return u
				})
		},
		newGroups() {
			const ug = this.usersGroups.map((g) => g._id)
			return this.groups.filter((g) => !ug.includes(g._id))
		},
		rolesUsers() {
			const users = this.users.filter((u) =>
				this.role === 'unverified'
					? !u.roles.includes('verified')
					: u.roles.includes(this.role)
			)
			users.sort((a, b) => a.name.localeCompare(b.name))
			return users
		},
		user() {
			return this.users.filter((u) => u._id === this.userId)[0]
		},
		usersGroups() {
			return this.groups.filter((g) => this.user.groups.includes(g._id))
		},
	},
	methods: {
		// init model

		async fetchAll() {
			this.loading = true
			await Promise.all([this.fetchGroups(), this.fetchUsers()])
			this.loading = false
		},
		async fetchGroups() {
			const groups = await apiClient.groupFind()
			groups.sort((a, b) => a.name.localeCompare(b.name))
			this.groups = groups
			if (this.groups && !this.group) this.groupId = this.groups[0]._id
		},
		async fetchUsers() {
			const users = await apiClient.userFind()
			users.sort((a, b) => a.name.localeCompare(b.name))
			this.users = users
			if (this.users && !this.user) this.selectedUser = this.users[0]
		},

		// update model

		updateGroup(modifiedGroup) {
			const i = this.groups.map((g) => g._id).indexOf(modifiedGroup._id)
			this.$set(this.groups, i, modifiedGroup)
		},
		updateUser(modifiedUser) {
			const i = this.users.map((u) => u._id).indexOf(modifiedUser._id)
			this.$set(this.users, i, modifiedUser)
		},

		// actions

		async addUserToGroup(group, user) {
			this.loading = true
			const res = await apiClient.groupAddUser(group._id, user._id)
			this.updateGroup(res.group)
			this.updateUser(res.user)
			this.loading = false
		},
		async changeSaveTo(user, group) {
			if (confirm(`Change save to of ${user.name} to ${group.name}?`)) {
				this.loading = true
				const modifiedUser = await apiClient.userChangeSaveTo(
					user._id,
					group._id
				)
				this.updateUser(modifiedUser)
				this.loading = false
			}
		},
		async removeFromGroup(group, user) {
			if (confirm(`Remove ${user.name} from ${group.name}?`)) {
				this.loading = true
				const res = await apiClient.groupRemoveUser(group._id, user._id)
				this.updateGroup(res.group)
				this.updateUser(res.user)
				this.loading = false
			}
		},
		async toggleGlobalRole(user, role) {
			this.loading = true
			const modifiedUser = await apiClient.userToggleGlobalRole(
				user._id,
				role
			)
			this.updateUser(modifiedUser)
			this.loading = false
		},
		async toggleGroupRole(group, user, role) {
			this.loading = true
			const modifiedGroup = await apiClient.groupToggleUserRole(
				group._id,
				user._id,
				role
			)
			this.updateGroup(modifiedGroup)
			this.loading = false
		},
	},
	mounted() {
		this.fetchAll()
	},
}
</script>
